import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="relative w-full bg-[#0a0e1a] text-[#f5f5f0] overflow-hidden pt-12 pb-20 px-6 md:px-12 lg:px-20" data-id="element-54">
      {/* Background subtle gradient */}
      <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-[#111827] to-[#0a0e1a] opacity-50 pointer-events-none" data-id="element-55" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col gap-8" data-id="element-57">
          <div className="inline-flex items-center self-start px-3 py-1 rounded-full bg-amber-900/30 border border-amber-700/50 text-amber-400 text-xs font-bold uppercase tracking-wider" data-id="element-58">
            Protocolo de 14 días
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight" data-id="element-59">
            No es que no tengas fuerza de voluntad: <br data-id="element-60" />
            <span className="text-amber-500" data-id="element-61">
              es que tu noche está abierta.
            </span>
          </h1>

          {/* Mockup image right below headline */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex justify-center my-4" data-id="element-62">
            <div className="relative w-full max-w-sm md:max-w-md rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-gray-800" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/56ke4fM6i1jbTJhNLXpPk1/AtraconesMOCKUP.png" alt="Cero Atracones Nocturnos Mockup" className="w-full h-auto object-cover" data-id="element-64" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-transparent to-transparent opacity-40" data-id="element-65" />
            </div>
          </motion.div>

          <div className="space-y-6 text-lg md:text-xl leading-[1.8] text-gray-300 font-light" data-id="element-66">
            <p data-id="element-67">
              Si por la mañana eres "la versión seria de ti",
              <br data-id="element-68" />
              pero por la noche te conviertes en alguien que no reconoces…
            </p>

            <p className="border-l-2 border-amber-500/30 pl-4 italic text-gray-400" data-id="element-69">
              No necesitas otra dieta.
              <br data-id="element-70" />
              Ni otra app.
              <br data-id="element-71" />
              Ni otra promesa a las 2:13am.
            </p>

            <p data-id="element-72">
              Necesitas una cosa más simple (y más incómoda):
              <br data-id="element-73" />
              <strong className="text-white font-semibold" data-id="element-74">
                cerrar la noche.
              </strong>
            </p>

            <p data-id="element-75">
              Porque ahora mismo tu noche está abierta.
              <br data-id="element-76" />
              Abierta a cansancio. Abierta a ansiedad. Abierta a "me lo
              merezco".
              <br data-id="element-77" />
              Abierta a ese primer movimiento que haces casi sin pensar:
              <br data-id="element-78" />
              levantarte… abrir la cocina… y entrar en piloto automático.
            </p>

            <p data-id="element-79">
              Y lo peor no es lo que comes.
              <br data-id="element-80" />
              Lo peor es lo que viene después:
              <br data-id="element-81" />
              la vergüenza, el asco, el "mañana compenso", el "ya lo arruiné",
              <br data-id="element-82" />y esa sensación de que estás perdiendo una guerra que nadie
              ve.
            </p>

            <p className="text-amber-100/90 font-medium" data-id="element-83">
              Este sistema existe para una sola cosa:
              <br data-id="element-84" />
              que la noche no te secuestre.
            </p>
          </div>

          <div className="pt-4" data-id="element-85">
            <CtaButton text="Quiero cerrar la noche" data-id="element-86" />
          </div>
        </motion.div>
      </div>
    </section>;
}